import { AdProviderTypes, AdProvidersSettings, CustomAdUnitConfig, DirectProviderSettings, PlatformType } from '@/types'
import { getCurrentPlatform } from '@/utils/helpers'

import { MSN_STORE_CLID } from '../constants/general'

const COMMON_CAMPAIGN_ID = 'ms-store-fallback'

const MSN_STORE_FALLBACK_CONFIG: CustomAdUnitConfig[] = [
    {
        platforms: ['desktop'],
        campaignId: COMMON_CAMPAIGN_ID,
        creatives: [
            // Rooftop Run
            {
                name: '9plgt00f15xs',
                adUnits: ['interstitial', 'rewarded'],
                format: 'banner',
                file: 'f6a172bd-52d7-46a2-9180-7f2ea1853300',
                clickUrl: 'ms-windows-store://pdp/?productid=9plgt00f15xs',
                responsive: true,
            },

            // MR RACER - Car Racing
            {
                name: '9n08dpggwvqh',
                adUnits: ['interstitial', 'rewarded'],
                format: 'banner',
                file: '8e7e7b20-ddc8-4933-624e-cc6bc5802000',
                width: 540,
                height: 300,
                clickUrl: 'ms-windows-store://pdp/?productid=9n08dpggwvqh',
            },

            // Hazmob
            {
                name: '9n7qs1kn0v8l',
                adUnits: ['interstitial', 'rewarded'],
                format: 'banner',
                file: 'bdbfb342-d7e3-4c55-c04d-90ffc49d8900',
                width: 540,
                height: 300,
                clickUrl: 'ms-windows-store://pdp/?productid=9n7qs1kn0v8l',
            },
            // Speed per Click: Obby
            {
                name: '9pbp2j1pt8rd',
                adUnits: ['interstitial', 'rewarded'],
                format: 'banner',
                file: '369626f5-4886-4ff2-cdae-5bff9d6dfa00',
                width: 540,
                height: 300,
                clickUrl: 'ms-windows-store://pdp/?productid=9pbp2j1pt8rd',
            },
            // Gangsta Island: Crime City
            {
                name: '9p87g58gdfs8',
                adUnits: ['interstitial', 'rewarded'],
                format: 'banner',
                file: 'ce93059a-dfa2-4e3c-2e6e-c6a0e4180900',
                width: 540,
                height: 300,
                clickUrl: 'ms-windows-store://pdp/?productid=9p87g58gdfs8',
            },

            // Barry Prison Parkour Escape
            {
                name: '9pbbr7r5dnvz',
                adUnits: ['interstitial', 'rewarded'],
                format: 'banner',
                file: 'e2d4f385-381f-41aa-381a-fcfc181e2800',
                width: 540,
                height: 300,
                clickUrl: 'ms-windows-store://pdp/?productid=9pbbr7r5dnvz',
            },
            // Geometry Arrow
            {
                name: '9p3gwtlnq3ss',
                adUnits: ['interstitial', 'rewarded'],
                format: 'video',
                file: '9b9743c86eed4a879194c60596357f53',
                clickUrl: 'ms-windows-store://pdp/?productid=9p3gwtlnq3ss',
                skippable: true,
            },

            // Moto X3M
            {
                name: '9pfc45g1xhp7',
                adUnits: ['interstitial', 'rewarded'],
                format: 'video',
                file: '236ada3eea264401b7be98a0466cd6ce',
                clickUrl: 'ms-windows-store://pdp/?productid=9pfc45g1xhp7',
                skippable: true,
            },

            // Hedgies
            {
                name: '9nwgnsdn6r0t',
                adUnits: ['interstitial', 'rewarded'],
                format: 'video',
                file: '5190b1fcdbba4021a45c3930c54161e2',
                clickUrl: 'ms-windows-store://pdp/?productid=9nwgnsdn6r0t',
                skippable: true,
            },

            //  Age of Tanks Warriors: TD War
            {
                name: '9nxv05zxpkq7',
                adUnits: ['interstitial', 'rewarded'],
                format: 'video',
                file: 'd60b3bcee2174db1948f70ccbba67d7d',
                clickUrl: 'ms-windows-store://pdp/?productid=9nxv05zxpkq7',
                skippable: true,
            },

            // Basketball Superstars
            {
                name: '9p7cq8wcc3j7',
                adUnits: ['interstitial', 'rewarded'],
                format: 'video',
                file: 'c0fb61f2cb2a00cb11d95fdd283b5de0',
                clickUrl: 'ms-windows-store://pdp/?productid=9p7cq8wcc3j7',
                skippable: true,
            },

            //  Gym Simulator Online Escape
            {
                name: '9plc0zqln6fw',
                adUnits: ['interstitial', 'rewarded'],
                format: 'video',
                file: '5407857b9ace538d7954b7ab734ffc6a',
                clickUrl: 'ms-windows-store://pdp/?productid=9plc0zqln6fw',
                skippable: true,
            },
        ],
    },
]

export const COMMON_MSN_STORE_OPTIONS = {
    timeout: 5000,
    adSettings: {
        initialDelayMs: 300_000, // 5min
        intervalsMs: 300_000, //5min
    },
    adUnitConfig: MSN_STORE_FALLBACK_CONFIG,
}

export const getMsnStoreFallbackProvider = (options: { platform: PlatformType }): DirectProviderSettings => {
    return {
        type: AdProviderTypes.DIRECT,
        options: {
            ...options,
            ...COMMON_MSN_STORE_OPTIONS,
            locale: 'en-US',
        },
    }
}

export function setFallbackProviders(clid: string | undefined): AdProvidersSettings[] {
    if (clid === MSN_STORE_CLID) {
        return [
            getMsnStoreFallbackProvider({
                platform: getCurrentPlatform(window.navigator.userAgent),
            }),
        ]
    }
    return []
}
